/* Redux */
import { useDispatch, useSelector } from 'src/redux/hooks'

const Redux = () => {
  const dispatch = useDispatch()

  // User-Infos
  const { token, email } = useSelector(store => store.User)

  // Login
  const reduxLogin = (data:{
    token: string
    email: string
  }) =>
    dispatch({ type: 'login', payload: data })

  // Logout
  const reduxLogout = () =>
    dispatch({ type: 'logout' })

  return {
    token, email,
    
    reduxLogin,
    reduxLogout,
  }
}

export default Redux
